import { create } from 'zustand'
import { ONBOARDING_COMPLETION_BONUS } from '../config/onboardingRegistry'

interface OnboardingCelebrationState {
  pulseKey: number
  pointsAdded: number
  completionBonus: number
  showModal: boolean
  showPostOnboardingUpsell: boolean
  trigger: (pointsAdded: number, completionBonus?: number) => void
  dismissModal: () => void
  dismissPostOnboardingUpsell: () => void
}

/** Subtelny impuls dla badge salda + modal po ukończeniu onboardingu. */
export const useOnboardingCelebration = create<OnboardingCelebrationState>((set) => ({
  pulseKey: 0,
  pointsAdded: 0,
  completionBonus: ONBOARDING_COMPLETION_BONUS,
  showModal: false,
  showPostOnboardingUpsell: false,
  trigger: (pointsAdded, completionBonus = ONBOARDING_COMPLETION_BONUS) =>
    set((s) => ({
      pulseKey: s.pulseKey + 1,
      pointsAdded,
      completionBonus,
      showModal: true,
      showPostOnboardingUpsell: true,
    })),
  dismissModal: () => set({ showModal: false }),
  dismissPostOnboardingUpsell: () => set({ showPostOnboardingUpsell: false }),
}))
